import { Button, notification, Popconfirm, Radio, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { NavigateFunction } from "react-router-dom";

import { deleteRegion } from "../../../services/regionsApi";

export interface DataType {
  id: number;
  name: string;
  price?: number;
}

const confirm = async (id: number, navigate: NavigateFunction) => {
  try {
    await deleteRegion(id);
    notification.success({
      message: `La región ha sido eliminada correctamente!`,
      placement: "bottom",
      duration: 2,
      onClose() {
        navigate(0);
      },
      key: "global",
    });
  } catch (error: any) {
    console.log(error);
    notification.error({
      message: error.response.data.message,
      placement: "bottom",
      key: "global",
    });
  }
};

const ConfirmDeleteRegion = ({
  id,
  navigate,
}: {
  id: number;
  navigate: NavigateFunction;
}) => (
  <Popconfirm
    title="Estás seguro de eliminar esta región?"
    onConfirm={() => confirm(id, navigate)}
    okText="Si"
    cancelText="No"
  >
    <Button danger>Eliminar</Button>
  </Popconfirm>
);

type ColumnsProps = {
  navigate: NavigateFunction;
  selectedRegionId: number | null;
  setSelectedRegionId: React.Dispatch<React.SetStateAction<number | null>>;
};

export const columns = ({
  navigate,
  selectedRegionId,
  setSelectedRegionId,
}: ColumnsProps): ColumnsType<DataType> => [
  {
    dataIndex: "id",
    render: (id: number) => (
      <Radio
        checked={selectedRegionId === id}
        onChange={() => setSelectedRegionId(id)}
      />
    ),
    width: 80,
  },
  {
    title: "Nombre",
    dataIndex: "name",
    sorter: false,
    width: "60%",
  },
  {
    key: "action",
    width: "20%",
    render: (_, record) => (
      <Space size="middle">
        <ConfirmDeleteRegion id={record.id} navigate={navigate} />
      </Space>
    ),
  },
];
